import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {QtoolsModel, Qtools} from './../../models/qtools.model';

@Component({
  selector: 'app-modal-qtools',
  templateUrl: './modal-qtools.component.html',
  styles: []
})
export class ModalQtoolsComponent implements OnInit {

  formControl = new FormControl('');
  modalForm : FormGroup;
  qtool: Qtools;
  private _qtoolModel = new QtoolsModel ;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit() {
    this.modalForm = this.fb.group({
      clave: [this.qtool ? this.qtool.clave : null],
      nombre: [this.qtool ? this.qtool.nombre : null],
      url: [this.qtool ? this.qtool.url : null],
      user: [this.qtool ? this.qtool.user : null],
      password: [this.qtool ? this.qtool.password : null],
      descripcion: [this.qtool ? this.qtool.descripcion : null],
    });
  }

  //Agregar dominio
  adminQTool(){
    this.activeModal.close('Guardado datos');
      this._qtoolModel.createQtools(this.modalForm.value);
  }

}
